import type { ISocialAccount } from '@components';
import type { AudienceSummaryData } from '@/applications/Social/creator-search/instagram/components/audience-summary-section/hooks';

export const memberAudienceSummaryAdapter = (
  socialData: ISocialAccount,
): AudienceSummaryData => {
  // Extract engagements per post
  const engagementsPerPost = socialData.engagement ?
    Math.round(socialData.engagement).toLocaleString() : '--';

  // Extract impressions per post
  const impressionsPerPost = socialData.impressions ?
    Math.round(socialData.impressions).toLocaleString() : '--';

  // Extract audience authenticity
  let audienceAuthenticity = '--';
  if (socialData.follower_score !== undefined && socialData.follower_score !== null) {
    const percentage = Math.round(socialData.follower_score);
    let label = '';

    if (percentage >= 80) {
      label = 'High';
    } else if (percentage >= 60) {
      label = 'Medium';
    } else {
      label = 'Low';
    }

    audienceAuthenticity = `${percentage}% (${label})`;
  } else if (socialData.audience_authenticity_label) {
    audienceAuthenticity = socialData.audience_authenticity_label;
  }

  return {
    engagementsPerPost,
    impressionsPerPost,
    audienceAuthenticity
  };
};
